import { useNavigate } from "react-router-dom";
import { useContext, useRef, useState } from "react";
import { SetPrintDataContext } from "../../Pages";
import axios from "axios";
import "./sidebarAssistant.css";

import TotalSideItem from "./TotalSideItem";
export default function SidebarAssistantItem({ arr }) {
  const mainSideRef = useRef(null);

  const [isLevelOpen, setIsLevelOpen] = useState(false);

  const setBill = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  function sideBill(e) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl2")}w/trd/`,
      params: {
        id: e.target.id,
        level: e.target.dataset.level,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setBill(response.data);
      navigate("/assistant/bill");
    });
  }

  return arr.map((i, index) => {
    return (
      <li key={index} className="main-sides-item" ref={mainSideRef}>
        <span>
          <span
            onClick={() => {
              setIsLevelOpen(!isLevelOpen);
            }}
          >
            +
          </span>
          <span className="nude-menu" onClick={sideBill}>
            {i.name}
          </span>
          {i.subMenu !== undefined && isLevelOpen && (
            <ul className="sub-main-menu">
              {i.subMenu !== [] &&
                i.subMenu.map((item) => {
                  return <TotalSideItem data={item} key={item.id} />;
                })}
            </ul>
          )}
        </span>
      </li>
    );
  });
}
